import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { SnackbarContainer } from 'components/standalone';
import { extractErrorMessage } from 'utils';
import { SupplierContainer, SupplierFormValues } from '../containers';
import { SupplierForm } from '../components';

const SuppliersCreateInner = () => {
  const classes = useStyles();
  const history = useHistory();
  const { notify } = SnackbarContainer.useContainer();
  const {
    formLoading,
    createSupplier,
    loadRegionOptions,
    loadUserRepresentativeOptions,
    setFormLoading,
    regionsError,
  } = SupplierContainer.useContainer();

  const handleSubmit = useCallback(
    async (values: SupplierFormValues) => {
      setFormLoading(true);
      try {
        // Single transactional request: supplier + regions + representatives.
        const created = await createSupplier(values);

        notify('Element created');
        history.push(`/supplier/${created.id}`);
      } catch (error: unknown) {
        console.error('Supplier create failed:', error);
        notify(
          extractErrorMessage(error, 'Error while creating the supplier'),
          'error',
        );
      } finally {
        setFormLoading(false);
      }
    },
    [createSupplier, history, notify, setFormLoading],
  );

  const handleGoBack = useCallback(() => {
    history.push('/supplier');
  }, [history]);

  return (
    <Box className={classes.formContainer}>
      <SupplierForm
        mode="create"
        onSubmit={handleSubmit}
        loading={formLoading}
        onGoBack={handleGoBack}
        loadRegionOptions={loadRegionOptions}
        loadUserRepresentativeOptions={loadUserRepresentativeOptions}
        regionsError={regionsError}
      />
    </Box>
  );
};

export const SuppliersCreate = () => (
  <SupplierContainer.Provider>
    <SuppliersCreateInner />
  </SupplierContainer.Provider>
);

const useStyles = makeStyles(theme => ({
  formContainer: {
    position: 'relative',
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.background.paper,
  },
}));

export default SuppliersCreate;
